import { Observable, of } from 'rxjs';

import { Injectable, Optional } from '@angular/core';
import {
  Router,
  UrlTree,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  ActivatedRouteSnapshot,
} from '@angular/router';

import { PublicOrganization } from '@lib/auth/public';

@Injectable()
export class SnRegistryGaurd implements CanActivate, CanActivateChild {
  constructor(private readonly _router: Router, @Optional() private readonly _org: PublicOrganization) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    if (state.url.startsWith('/validate-email')) {
      if (state.root.queryParams.token) {
        return of(true);
      } else {
        return of(this._router.createUrlTree(['/']));
      }
    }

    if (state.url === '/' && this._org?.registryRedirectUrl) {
      window.location.href = this._org.registryRedirectUrl;
    }
    if (state.url === '/' && this._org?.prefix === 'cityofstarkville') {
      return of(this._getRedirectUnauthorizedTo());
    }
    if (state.url === '/' && this._org?.prefix === 'henrycountypd') {
      window.location.href = 'https://sites.google.com/fusus.com/connecthenry/';
    }
    return of(true);
  }

  public canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.canActivate(route, state);
  }

  private _getRedirectUnauthorizedTo(): UrlTree {
    return this._router.createUrlTree(['/camera-registry']);
  }
}
